import { UseCase } from "../../base";
import { MasterlocationRepository } from "../../repositories";
import { Observable } from "rxjs";
import { PrivateLocatioDetails,  } from "../../domain/models";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GetPrivateLocationDetailUsecase implements UseCase<string, PrivateLocatioDetails> {
  constructor(private readonly masterlocationRepository : MasterlocationRepository) {
  }

  execute(request: string): Observable<PrivateLocatioDetails> {
    return this.masterlocationRepository.getPrivateLocationsDetails(request);
  }
}